<div
    class="block"
    [style.width.px]="width"
    [style.height.px]="height"
></div>
